import { render } from "./SelectInvestor.vue?vue&type=template&id=1bf16cfb&scoped=true"
import script from "./SelectInvestor.vue?vue&type=script&lang=js"
export * from "./SelectInvestor.vue?vue&type=script&lang=js"

import "./SelectInvestor.vue?vue&type=style&index=0&id=1bf16cfb&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1bf16cfb"]])

export default __exports__